<template id="upload-input">
  <div>
    <!-- PRETTY FILE INPUT HIDDEN -->
    <div class="input-group fileUploadDiv">
      <input type="text" class="form-control" placeholder="Select File..." :value="filenameVal()" readonly>
      <span class="input-group-btn">
    <button v-if="file != null" class="btn btnUpload deleteBtn" type="button" @click="clearFile">
     <span class="fas fa-trash-alt" aria-hidden="true"></span>
    </button>
    <button class="btn btnUpload " type="button" @click="launchFilePicker">
     <span class="fas fa-folder-open" aria-hidden="true"></span>
    </button>
   </span>
    </div>
    <!-- REAL FILE INPUT HIDDEN -->
    <ValidationProvider rules="required" v-slot="{errors, validate}" :name="hidden_id" tag="div" class="" v-if="required">
      <input type="file" hidden="hidden" ref="file" :id="hidden_id" :name="hidden_id" :accept="accepted_file_type" v-uploader @change="validate"/>
      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
    </ValidationProvider>
    <input v-else hidden="hidden" type="file" ref="file" :id="hidden_id" :name="hidden_id" :accept="accepted_file_type" v-uploader :required="required"/>
  </div>
</template>

<script>
export default {
  name: "fileInput",
  props: ['selected_file', 'accepted_file_type', 'required', 'hidden_id'],
  data() {
    return {
      file: null
    }
  },
  directives: {
    uploader: {
      bind(el, binding, vnode) {
        el.addEventListener('change', e => vnode.context.file = e.target.files[0]);
      }
    },
  },
  watch: {
    file(val) {
      if (val !== null) {
        let sizeTemp = val.size / 1024000;
        let sizeOther1 = sizeTemp.toFixed(1);
      }
      this.$emit('file-chosen', val);
    },
    selected_file() {
      if (this.selected_file === null) {
        this.file = null;
      }
    }
  },
  methods: {
    filenameVal() {
      if (this.file !== null) {
        return this.file.name
      }
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    clearFile() {
      this.file = null;
      document.getElementById(this.hidden_id).value = "";
    }
  }
}
</script>
<style scoped lang="scss">
.fileUploadDiv {
  height: 40px;

  input {
    height: 100%;
  }

  .input-group-btn {
    height: 100%;

    .btnUpload {
      height:           100%;
      border-radius:    0 0.25rem 0.25rem 0;
      float:            left;
      background-color: $bc_1;
      border-color:     $bc_1;
      color:            $white;

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        background-color: darken($bc_1, 15%);
        border-color:     darken($bc_1, 15%);
      }
    }

    .deleteBtn {
      border-radius:    0 !important;
      background-color: $red;
      border-color:     $red;
      color:            $white;

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        background-color: darken($red, 15%);
        border-color:     darken($red, 15%);
      }
    }
  }
}

.form-control {
  background-color: transparent;
}
</style>
